export default __webpack_public_path__ + "static/champagne-5ecf46e45ce1bfba7ec2efde72fce2d7.jpg";